// extracted by mini-css-extract-plugin
module.exports = {"orderButton":"idt-photoprintswindowmobile_orderbutton__2z_4b"};